import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-common/src/async.tsx';
import {
	setPerformanceMarkLoadStart,
	setPerformanceMarkLoadEnd,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/performance-marks/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { PlanSidebar as PlanSidebarType } from './ui/index.tsx';

const LazyPlanSidebar = lazyForPaint<typeof PlanSidebarType>(
	() => {
		setPerformanceMarkLoadStart();
		return import(/* webpackChunkName: "async-sidebar-plan" */ './index').then((bundle) => {
			setPerformanceMarkLoadEnd();
			return bundle;
		});
	},
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: false,
	},
);

const PlanSidebar = memo(() => (
	<SidebarBoundary id="Plan">
		<LazyPlanSidebar />
	</SidebarBoundary>
));

PlanSidebar.displayName = 'PlanSidebar';

export default PlanSidebar;
